import {computed} from "vue";

export function formatDate(date) {
    date = toDate(date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mois entre 0-11, ajouter 1
    const day = String(date.getDate()).padStart(2, '0'); // Ajouter un zéro pour les jours < 10

    return `${year}-${month}-${day}`;
}

export function toFrenchDate(date) {
    date = toDate(date);
    const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
    return new Date(date).toLocaleDateString('fr-FR', options);
}

export function formatForTime(date) {

    if (typeof date === 'string') {
        date = new Date(date);
    }
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
}

export function toDate(date) {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return date;
}

export function rangeOneYear() {
    const today = new Date()
    const year = today.getFullYear()
    const start = new Date(year, 0, 1)
    const end = new Date(year, 11, 31)
    return {
        start: formatDate(start),
        end: formatDate(end)
    }
}

export function rangeOneMonth() {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()
    const start = new Date(year, month, 1)
    const end = new Date(year, month + 1, 0)
    return {
        start: formatDate(start),
        end: formatDate(end)
    }
}

export function rangeOneWeek() {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()
    const day = today.getDate()
    const start = new Date(year, month, day - today.getDay())
    const end = new Date(year, month, day + (6 - today.getDay()))
    return {
        start: formatDate(start),
        end: formatDate(end)
    }
}

export function rangeOneDay() {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()
    const day = today.getDate()
    const start = new Date(year, month, day)
    const end = new Date(year, month, day)
    return {
        start: formatDate(start),
        end: formatDate(end)
    }
}
